import { render, staticRenderFns } from "./detailRecommendItemColumn.vue?vue&type=template&id=3a72d96f&scoped=true&"
import script from "./detailRecommendItemColumn.vue?vue&type=script&lang=js&"
export * from "./detailRecommendItemColumn.vue?vue&type=script&lang=js&"
import style0 from "./detailRecommendItemColumn.vue?vue&type=style&index=0&id=3a72d96f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a72d96f",
  null
  
)

export default component.exports